/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import { useNavigate } from 'react-router-dom';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const AccountTable = ({ columns, data, isSearching, ...otherProps }) => {
  const navigate = useNavigate();
  //Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    setPageSize,
    pageCount,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        sortBy: [
          {
            id: 'ProcessedDate',
            desc: true,
          },
        ],
      },
    },
    useSortBy,
    usePagination,
  );

  const onClick = (ele, index) => {
    if (ele && index === 2) {
      console.log(ele, 'PageRedirect');
      //navigate( `/admin/claim-details?CID=${ele}&source=account` );
      navigate('/admin/claim-details', {
        search: `?CID=${ele}&source=account`,
        state: otherProps.preserveData,
      });
    }
  };
  //Render the UI for your table
  return (
    <div>
      <table className="table padding-mobile-0" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, index) => (
            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => {
                return (
                  <th
                    key={index}
                    {...column.getHeaderProps(
                      column.getSortByToggleProps({ title: undefined }),
                    )}
                    className={
                      column.isSorted ? 'coloumnIsSorted' : 'coloumnNotSorted'
                    }
                  >
                    <b>{column.render('Header')}</b>
                    <span
                      className={
                        column.isSorted
                          ? column.isSortedDesc
                            ? 'arrowUp'
                            : 'arrowDown'
                          : 'arrowNormal'
                      }
                    ></span>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <tr key={index} {...row.getRowProps()}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      key={index}
                      className={
                        index == 2
                          ? 'cursor-pointer account-table-custom-link'
                          : ''
                      }
                      {...cell.getCellProps()}
                      onClick={() => onClick(row.original.ClaimOid, index)}
                    >
                      <p className="accounts-data">
                        {index === 3 || index === 4 || index === 5
                          ? formatter.format(isNaN(cell.value) ? 0 : cell.value)
                          : cell.render('Cell')}
                      </p>
                    </td>
                  );
                })}
              </tr>
            );
          })}
          {pageCount >= 2 && (
            <tr className="tr-showmore">
              <td>
                <button
                  id="showmore"
                  className="unstyled-button"
                  onClick={() => {
                    setPageSize(pageCount * pageSize);
                    console.log('page size: ', pageCount * pageSize);
                    document.getElementById('showmore').style.visibility =
                      'hidden';
                  }}
                >
                  Show more…
                </button>
              </td>
            </tr>
          )}
          {/*<tr>
            <td>
              {pageCount == 1  && (<div>&nbsp; </div>)}
            </td>
          </tr> */}
        </tbody>
        {(!isSearching || pageCount >= 2) && (
          <tfoot>
            {footerGroups.map((footerGroup, index) => (
              <tr key={index} {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column, i) => (
                  <td {...column.getFooterProps} key={i}>
                    {column.render('Footer')}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot>
        )}
      </table>
    </div>
  );
};

export default AccountTable;
